import axios from 'axios';
import Files from './Files';
import Panel from './Panel';
import Schedule from './Schedule';
import MasterData from './MasterData';
import Admin from './Admin';
import Reports from './Reports';
import Explorer from './Explorer';
import Rh from './Rh';
import UsersConfig from './UsersConfig';
import {Auth} from "aws-amplify";
import LogRocket from "logrocket";


export default {
    Files,
    Panel,
    Schedule,
    MasterData,
    Admin,
    Reports,
    Explorer,
    Rh,
    UsersConfig
};

export const getCancelToken = () => {
    const CancelToken = axios.CancelToken;
    return CancelToken.source();
};

export const validToken = () => {
    return Auth.currentSession()
        .then(data => {
            localStorage.setItem('token', data.getIdToken().getJwtToken());
            return true;
        })
        .catch(err => {
            LogRocket.captureException(err);
            localStorage.setItem('token', "");
            return false;
        })
};

export const getAccessJwtToken = async () => {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
};
